<div class="card" [style.backgroundColor]="backgroundColor">
  <!-- list header -->
  <div class="header">
    <img *ngIf="headerImage && !headerIcon" [src]="headerImage" [alt]="headerTitle" />
    <mat-icon [style.color]="headerIconColor" *ngIf="!headerImage && headerIcon">{{headerIcon}}</mat-icon>
    <span>{{headerTitle}}</span>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
